import { LoadingButton, LoadingButtonProps } from '@mui/lab';
import { Icon } from '../../icon/icon';

export const ActionButton = (
  props: Partial<LoadingButtonProps> & { secondary?: boolean }
) =>
  props.secondary ? (
    <LoadingButton fullWidth size="large" variant="outlined" {...props} />
  ) : (
    <LoadingButton
      endIcon={<Icon icon="ArrowRight" />}
      fullWidth
      color="primary"
      size="large"
      variant="contained"
      {...props}
    />
  );
